import DebugEvent from "../../ngt/debug/DebugEvent";
import AbstractCommand from "./AbstractCommand";

export default class PreloadCompleteCommand extends AbstractCommand {

    /**
     * Executes project specific code that is not done by Tasks added to the startup sequence.
     * Everything in this command should either be sync or game start should not be dependent on completion.
     * @param {soma.EventDipatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);
    }

    execute(event) {
        
        // Add debug skip content functionality:
        var dispatcher = this._dispatcher;

        document.addEventListener('keydown', function (event) {
            if (event.keyCode === 27) {
                var event = new DebugEvent(DebugEvent.SKIP_CONTENT);
                dispatcher.dispatch(event.type, { data: event });
            }
        });

        // Double click skipping for tablets
        var handleTouchDoubleClick = (function () {
            var touchCount = 0;
            var timeout = null;
            return function () {
                if (touchCount === 0) {
                    // Timeout to reset click count
                    timeout = setTimeout(function () {
                        // There was no double touch => Reset / Clean up
                        touchCount = 0;
                        clearTimeout(timeout);
                        timeout = null;
                    }, 500); // Double touch has to be within 500 ms (this is what windows uses as default)
                }

                touchCount++;

                // If there is more than 1 touch, count it as a double touch and skip the content
                if (touchCount > 1) {
                    var event = new DebugEvent(DebugEvent.SKIP_CONTENT);
                    dispatcher.dispatch(event.type, { data: event });
                    // Reset / Clean up
                    touchCount = 0;
                    clearTimeout(timeout);
                    timeout = null;
                }
            };
        })();

        document.addEventListener('touchstart', function (event) {
            handleTouchDoubleClick();
        });
    }

}